module.exports = __webpack_public_path__ + "img/view_quilt.21ab2126.svg";